import type { FollowUpCategoryTypes } from '@/shared/api/graphql/account';
import type { RelyingPartyAdminData } from '@/shared/lib/types/administration';
import type { JSONData } from '@/shared/ui/JsonKit';
import type { DateInput } from '@fullcalendar/core';

export enum FollowupActionType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE'
}

export enum VisitMode {
  IN_PERSON = 'IN_PERSON',
  VIRTUAL = 'VIRTUAL'
}

export type ReminderConfigurationsType = {
  daysBefore: number;
  reminderMode?: VisitMode | null;
};

export type TemplateVariable = {
  key: string;
  value: string;
};

export enum ReminderTemplateUnavailableReason {
  MISSING_PHARMACY_ADDRESS = 'MISSING_PHARMACY_ADDRESS'
}

export type ReminderMessageTemplateOption = {
  mode: VisitMode;
  label: string;
  template: string;
  isAvailable: boolean;
  unavailableReason?: ReminderTemplateUnavailableReason | string | null;
};

export type DefaultFollowUpEditType = {
  id: string;
  truentityId: string;
  followUpDueDate: DateInput;
  type: string;
  note: string;
  status: string;
  taskAssignees: RelyingPartyAdminData;
  category: FollowUpCategoryTypes;
  immediateActions?: JSONData;
};
